/* © CNES */
import { ProductsAdded } from '../../../models/ProductsAdded';
import { ItemsData } from '../ItemsData/ItemsData';
import './InnerRecoveringFromArchive.scss';

/**
 * InnerRecoveringFromArchive displays a list of products in Tier 3 added by user.
 * @param productsAdded The products Tier 3 added by user logged in.
 * @returns Element.
 */
export const InnerRecoveringFromArchive = ({
  productsAdded,
}: {
  productsAdded: ProductsAdded;
}) => {
  return (
    <div className="InnerAdded">
      <ItemsData productsAdded={productsAdded} isArchived />
    </div>
  );
};
